import { useLocation } from "react-router-dom";

import { EventBus } from "./events";
import { useEvent } from "./eventsHooks";

export const SEARCH_ID = "search-input-unique-id";

let isSearchOpen = false;

export function setSearchOpen(open: boolean) {
    isSearchOpen = open;
}

export function isSearchSidebarOpen() {
    return isSearchOpen;
}

export function getSearchInput() {
    return document.getElementById(SEARCH_ID) as HTMLInputElement | null;
}

export function SearchTrap() {
    const location = useLocation();
    useEvent(EventBus.ui.search, () => {
        if (location.pathname.includes("/contacts")) {
            getSearchInput()?.focus();
        } else {
            EventBus.ui.sidebar.emit("search");
            setTimeout(() => {
                const newInput = document.getElementById(
                    "search-input-main",
                ) as HTMLInputElement | null;
                if (newInput) newInput.focus();
                else getSearchInput()?.focus();
            }, 100);
        }
    });
    return null;
}
